export default function Crest({ className = "w-10 h-10" }) {
  return (
    <img
      src="/kush-seal.png?v=3"
      alt="Official seal — United States of Africa, Kingdom of Kush"
      className={`${className} rounded-full`}
      data-testid="usa-crest"
    />
  );
}
